<template>
    <div class="upload">
        <div class="control">
            <div class="upload__select p1 t-dark-grey lh-reset bg-white px-1 px-sm-2 py-2">
                <file-upload
                    :post-action="postFoo()"
                    class="file-upload"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :multiple="true"
                    :size="1024 * 1024 * 10"
                    v-model="files"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                    ref="upload">
                    Choose files
                </file-upload>
            </div>
        </div>
        <div class="control">
            <button class="btn btn-upload" v-if="!$refs.upload || !$refs.upload.active"
                    @click.prevent="$refs.upload.active = true">Start Upload
            </button>
            <button class="btn btn-upload" v-else @click.prevent="$refs.upload.active = false">Stop Upload</button>
        </div>

        <div class="upload__files mt-4" v-if="files.length">
            <div class="t-navy lh-lg mb-1">Files to upload</div>
            <ul class="files t-navy rows">
                <li class="file odd row px-1 px-sm-3 py-12px t-navy w-100" v-for="(file, index) in files"
                    :key="file.id">
                    <div class="d-flex w-100">
                        <div class="column p-0 file__name fs-18 py-12px">{{file.name}}</div>
                        <div class="column p-0 file__btn text-right">
                            <a class="btn btn-ghost btn-small w-100 p-1" @click.prevent="confirmDelete(file, index)"
                               v-scroll-to="{el: '#confirmDelete',offset: -120}">Delete</a>
                        </div>
                    </div>
                </li>
                <li class="file row px-1 px-sm-3 py-12px t-navy w-100" v-if="showConfirm">
                    <div class="d-flex w-100 align-items-center" id="confirmDelete">
                        <div class="column is-8 font-weight-light p-0 py-12px">
                            Are you sure you want to delete <strong>{{fileToDelete.name}}</strong>?
                        </div>
                        <div class="column p-0 buttons text-right">
                            <a class="btn btn-ghost btn-small btn-small--navy w-100 p-1 mr-sm-2 mb-2 mb-sm-0"
                               @click.prevent="keepFile()">Keep</a>
                            <a class="btn btn-ghost btn-small w-100 p-1" @click.prevent="deleteFile()">Delete</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import FileUpload from 'vue-upload-component';
    import vueScrollto from 'vue-scrollto';
    import {mapActions, mapState} from "vuex";

    Vue.use(vueScrollto);

    export default {
        name: "CatUxoUploader",
        components: {
            FileUpload,
        },
        data() {
            return {
                files: [],
                showConfirm: false,
                fileToDelete: null,
                fileToDeleteIndex: null,
            }
        },
        watch: {
            files: {
                handler: function (val, oldVal) {
                    this.files = val;
                    this.storeFiles({files: this.files});
                },
                deep: true,
            }
        },
        computed: {
                ...mapState('form', [
                    'uploadFolder',
                    'uploadHazardId'
                ]),
        },
        methods: {
            postFoo() {
                return `/api/v1/upload?folder=${this.uploadFolder}&id=${this.uploadHazardId}`;
            },
            ...mapActions('form', [
                'isUploaded',
                'storeFiles'
            ]),
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Add a file

                    console.log(this.uploadFolder);
                    console.log(this.uploadHazardId);

                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }

                    // Filter php html js file
                    // php html js
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },
            inputFile(newFile, oldFile) {
                if (newFile && oldFile && !newFile.active && oldFile.active) {

                    // Get response data
                    // console.log('response', newFile.response.response);

                    if (newFile.xhr) {
                        //  Get the response status code
                        this.isUploaded({uploaded: this.$refs.upload.uploaded});
                    }
                }
            },
            confirmDelete(file, index) {
                this.fileToDelete = file;
                this.fileToDeleteIndex = index;
                this.showConfirm = true;
            },
            keepFile() {
                this.showConfirm = false;
                this.fileToDelete = null;
                this.fileToDeleteIndex = null;
            },
            deleteFile() {
                this.files.splice(this.fileToDeleteIndex, 1);
                this.showConfirm = false;
            },
        },
        filters: {
            formatSize(size) {
                if (size > 1024 * 1024 * 1024 * 1024) {
                    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
                } else if (size > 1024 * 1024 * 1024) {
                    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
                } else if (size > 1024 * 1024) {
                    return (size / 1024 / 1024).toFixed(2) + ' MB'
                } else if (size > 1024) {
                    return (size / 1024).toFixed(2) + ' KB'
                }
                return size.toString() + ' B'
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .file {
        &:nth-child(even) {
            background: $c-light-grey;
        }

        &:nth-child(odd) {
            background: $c-white;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/Uploader.vue